import { FiPlus } from "react-icons/fi";

interface AddNewCardProps {
	disabled?: boolean;
	label: string;
	onClick: () => void;
}

export const AddNewCard: React.FC<AddNewCardProps> = ({
	label,
	onClick,
	disabled = false,
}) => {
	return (
		<button
			type="button"
			onClick={onClick}
			disabled={disabled}
			className="flex min-w-[200px] flex-shrink-0 cursor-pointer flex-col items-center justify-center gap-2 rounded-lg border-2 border-dashed border-gray-300 p-6 text-gray-500 transition-colors hover:border-blue-400 hover:text-blue-500 disabled:cursor-not-allowed disabled:opacity-50"
		>
			<FiPlus size={24} />
			<span className="text-sm font-medium">{label}</span>
		</button>
	);
};
